/* =============================================================================
 * SKU direct search (GYPSY patch)
 * -----------------------------------------------------------------------------
 * When a shopper types a SKU-shaped query and submits, do an exact variants.sku
 * lookup and jump straight to the product instead of showing the fuzzy
 * relevance-ranked wall. Falls through to normal search for everything else.
 *
 * Self-contained: one capture-phase submit listener covers every /search form
 * (predictive, halo quick-search, plain header form). No edits to stock JS.
 * To remove: delete this file + its <script> include in layout/theme.liquid.
 * ========================================================================== */
(function () {
  'use strict';

  // A query looks like a part number when it has no spaces, is reasonably long,
  // contains at least one digit, and only uses alnum + a little punctuation.
  // Requiring a digit keeps ordinary word searches ("brake pads") out.
  function looksLikeSku(q) {
    return (
      q.length >= 5 &&
      !/\s/.test(q) &&
      /\d/.test(q) &&
      /^[A-Za-z0-9][A-Za-z0-9._\/-]*$/.test(q)
    );
  }

  function suggestUrl(q) {
    var root = (window.routes && window.routes.root) || '';
    var params = new URLSearchParams();
    params.set('q', q);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '10');
    // Restrict the search to the SKU field only → high-precision exact-ish match.
    params.set('resources[options][fields]', 'variants.sku');
    params.set('resources[options][unavailable_products]', 'last');
    return root + '/search/suggest.json?' + params.toString();
  }

  // Pick the destination URL: prefer a variant whose SKU matches exactly.
  function resolveTarget(products, q) {
    if (!products || !products.length) return null;
    var needle = q.toLowerCase();

    for (var i = 0; i < products.length; i++) {
      var variants = products[i].variants || [];
      for (var j = 0; j < variants.length; j++) {
        var sku = (variants[j].sku || '').toLowerCase();
        if (sku && sku === needle) {
          return variants[j].url || products[i].url;
        }
      }
    }

    // No per-variant SKU echoed back, but the field-restricted search returned a
    // single product → that's our unambiguous hit.
    if (products.length === 1) return products[0].url;

    return null; // ambiguous → let normal search render the results page
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/search') === -1) return;

    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var q = input.value.trim();
    if (!looksLikeSku(q)) return; // ordinary query → normal search

    // Take over: we'll either redirect to the exact product or resubmit natively.
    event.preventDefault();
    event.stopPropagation();

    fetch(suggestUrl(q), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var products =
          data && data.resources && data.resources.results
            ? data.resources.results.products
            : null;
        var target = resolveTarget(products, q);
        if (target) {
          window.location.href = target;
        } else {
          form.submit(); // native submit bypasses this listener → normal search
        }
      })
      .catch(function () {
        form.submit(); // any failure → fall back to normal search, never block
      });
  }

  document.addEventListener('submit', handleSubmit, true); // capture phase
})();
